import { FC, useMemo } from 'react'
import TickMark from 'src/Icon/TickMark'
import Popout from '../Popout'
import DropdownButton from './DropdownButton'
import { setType } from 'src/app/modal'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import { selectGroupName, selectGroupNames } from 'src/app/hostSettings'

type TagDropdownProps = {
  setSelectedOption: (groupId: string) => void
  selectedValue: string
  popoutWrapperStyles?: string
}

const TagDropdown: FC<TagDropdownProps> = ({
  selectedValue,
  setSelectedOption,
  popoutWrapperStyles,
}) => {
  const groupNames = useAppSelector(selectGroupNames)
  // we must memoize re-selectors if they will appear in different component instances
  const selectGroupNameMemo = useMemo(() => selectGroupName, [])
  const groupName = useAppSelector((state) =>
      selectGroupNameMemo(state, selectedValue)
  )
  const items = useMemo(() => Object.keys(groupNames), [groupNames])
  const dispatch = useAppDispatch()
  const onCreate = () => {
    dispatch(
      setType({
        type: 'groupCreate',
        props: { setSelectedGroupOnCreation: setSelectedOption },
      })
    )
  }

  return (
    <Popout
      popoutClass="rounded-lg bg-white shadow-tooltip border-borderGrey border-[0.5px] p-1 z-30"
      // this style prevents the extension of the click area outside the button
      wrapperStyles={`inline-block ${
        popoutWrapperStyles ? popoutWrapperStyles : ''
      }`}
      clickEnabled={true}
      hoverEnabled={false}
      ignoreMouse={false}
      dismissFloatingEnabled={true}
      placement={'bottom-start'}
      contents={
        <div className="w-[230px] overflow-auto max-h-[150px] scrollbar-hide pb-9">
          {items.map((groupName) => (
            <button
              key={groupName}
              className="px-2 py-1 w-full text-darkBlack hover:text-white hover:bg-primaryBlue flex items-center justify-between rounded-lg"
              onClick={() => {
                // will return the groupId
                setSelectedOption(groupNames[groupName])
              }}
            >
              {groupName}
              <span
                className={`${
                  // checks the groupId
                  selectedValue === groupNames[groupName] ? 'block' : 'hidden'
                } flex-shrink-0`}
              >
                <TickMark />
              </span>
            </button>
          ))}
          <div className="pt-1 w-[230px] bg-white flex justify-between border-t bottom-0 absolute">
            <button
              className="p-1 flex text-primaryBlue items-center rounded cursor-pointer "
              onClick={onCreate}
            >
              + Create New Tag
            </button>
          </div>
        </div>
      }
    >
      {() => (
        <DropdownButton
          ariaLabel="tag-dropdown"
          type= {groupName! ? "tag" : "emptyTag"}
          styles="flex items-center"
        >
          {groupName! ? groupName : '+ Tag'}
        </DropdownButton>
      )}
    </Popout>
  )
}

export default TagDropdown
